import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Email from "../../components/public/ResetPassword/Email";
import Password from "../../components/public/ResetPassword/Password";
import Welcome from "../../components/public/ResetPassword/Welcome";
import Verification from "../../components/public/ResetPassword/Verification";

export const ForgotPassword = ({ route = null }) => {
  const { search } = useLocation();
  const [step, setStep] = useState(search.slice(1, 6) === "token" ? 3 : 1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [status, setSuccessStatus] = useState(false);

  const handleEmailNext = (email, password) => {  
    setEmail(email);
    setPassword(password);
    setStep(2);
  };

  const handlePasswordBack = () => {
    setStep(1);
  };

  const handleVerifyNext = () => {
    setStep(3);
  };

  const handleNameNext = (status) => {
    setSuccessStatus(status);
    setStep(4);
  };

  return (
    <>
      {
        step === 1 && (<Email
          onNext={handleEmailNext}
          onEmail={email}
          PassNext={handleVerifyNext}
        />)
      }
      {
        step === 2 && (<Verification
          onNext={handleVerifyNext}
          onEmail={email}
          onPrev={handlePasswordBack}
        />)
      }
      {
        step === 3 && (<Password email={email} password={password} onNext={handleNameNext} route={route} />)
      }
      {
        step === 4 && (<Welcome status={status} step="onboard" />)
      }
    </>
  )
};
